module.exports = __webpack_public_path__ + "img/lens-167-minus-06.2a92a212.png";